import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import Collapse from "../../components/atoms/colapso";
import Footer from "../../components/organisms/footer";
import NavBar from "../../components/organisms/navbar";
import { FaMapMarkerAlt } from 'react-icons/fa';
//import useAuthenticate from "../../hooks/useAuthenticate";
import {
  Container,
  Content,
  H3,
  H5,
  Location,
  P,
  QRCodeImg,
  Span,
  Title,
  TournamentActions,
  TournamentBanner,
  TournamentContainer,
  TournamentContainerBanner,
  TournamentContent,
  TournamentDescription,
  TournamentEnrollmentLink,
  TournamentEnrollmentLinkEndpage,
  TournamentLink,
  EditalContainer,
  EditalContent,
  EditalTitle
} from "./styles";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../services/api";
import Swal from "sweetalert2";
// import tabelaPeso from "../../assets/images/tournaments/toledo-international-open-brazilian-jiu-jitsu-2023/tabepla-de-peso.jpeg";
import tabelaPeso from "../../assets/images/tournaments/i-copa-faixa-solidaria-de-jiu-jitsu-2025/tabela-i-copa-faixa-solidaria-de-jiu-jitsu-2025.jpg";

//Patrocinio
import torneio from "../../assets/images/sponsors/torneio-facil.png";
import govAm from "../../assets/images/sponsors/logo-gov-am.png";
import deputadoMaciel from "../../assets/images/sponsors/cabo-maciel.png";



//Apoio
import { SponsorContainer, SponsorList } from "src/components/atoms/sponsor-area/styles";
import SponsorButton from "src/components/atoms/sponsor-area";
import useAuthenticate from "../../hooks/useAuthenticate";

const sponsors = [
 
  { img: torneio, url: "http://www.torneiofacil.com" }
  
];


const support = [

  { img: torneio, url: "http://www.torneiofacil.com" },
];


const cacheBuster = `?cacheBuster=${new Date().getTime()}`

const dataEvento = " "
const horaEvento = " "
const tituloEvento = "COPA TORNRIO FÁCIL DE JIU JITSU"
const localEvento = " "
const endereçoEvento = " "
const dataDeEncerramentoIncricao = "10/NOV/2025"
const horaDeEncerramentoIncricao = "23h:59"

const dataDeEncerramentoCorrecao = "14/NOV/2025"
const horaDeEncerramentoCorrecao = "23h:59min"

const dataDeEncerramentoInscricaoLoteUnico = ""
const dataDeEncerramentoInscricaoLote1 = "Completar 1.000 atletas inscritos"
const dataDeEncerramentoInscricaoLote2 = "30/SET/2025"
const dataDeEncerramentoInscricaoLote3 = "22/OUT/2025"


const valorinscricaoCategoriaAbsoluto = "30,00 (trinta reais)"
const valorinscricaoCategoriaAbsolutoLote3 = "40,00 (quarenta reais)"
const valorinscricaoCategoriaLote1 = "40,00 (quarenta reais)"
const valorinscricaoCategoriaLote2 = "50,00 (cinquenta reais)"
const valorinscricaoCategoriaLote3 = "70,00 (setenta reais)"

const valorinscricaoLoteUnicoComboGieNogi = "200,00 (duzentos reais)"
const valorinscricaoLote1ComboGieNogi = "200,00 (duzentos reais)"
const valorinscricaoLote2ComboGieAbsoluto = "70,00 (setenta reais)"
const valorinscricaoLote3ComboGieAbsoluto = "100,00 (cem reais)"

const valorinscricaoAbsolutoLoteUnico = "100,00 (cem reais)"
const valorinscricaoAbsolutoLote2 = "75,00 (setenta e cinco reais)"

const dataDeDivulgacaoChaves = "15/NOV/2025"
const horaDeDivulgacaoChaves = "23h:59min"

const instituicaoBancaria = "Bradesco"
const tipoDeChavePix = "Telefone"
const ChavePix = "(92) 99468-5161"
const BeneficiarioDaChavePix = "José Michel Tavares Pio"

const dataDeDivulgacaoCronograma = " "
const horaDeDivulgacaoCCronograma = " "

const contatoWhatsApp = "(92) 99247-0538"
const contatoWhatsAppTorneio = "+55 (11) 94456-3515"

const slugGI = "copa-torneio-facil-de-jiu-jitsu-manaus-am-gi";
const slugNOGI = "i-copa-faixa-solidaria-de-jiu-jitsu-manaus-am-absoluto";
const rotaInscriçãoGi = `/enrollment/i-copa-faixa-solidaria-de-jiu-jitsu-manaus-am-gi`;
const rotaChecagemGi = "/check/i-copa-faixa-solidaria-de-jiu-jitsu-manaus-am-gi/search";
const rotaChecagemAbsoluto = "/check/i-copa-faixa-solidaria-de-jiu-jitsu-manaus-am-absoluto/search";
const rotaChavesGI = "/tournament/keys/i-copa-faixa-solidaria-de-jiu-jitsu-manaus-am-gi"
const rotaChavesAbsoluto = "/tournament/keys/i-copa-faixa-solidaria-de-jiu-jitsu-manaus-am-absoluto"



const CopaTorneioFacilDeJiuJitsu: React.FC = () => {
  const { authenticated, getToken } = useAuthenticate();
  const navigate = useNavigate();

  const handleToSubscriptionPage = async () => {

    if (!authenticated) {
      Swal.fire({
        title: 'Você precisa estar autenticado',
        text: 'Deseja fazer login para se inscrever no evento?',
        icon: 'info',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Fazer login',
        focusConfirm: false,
        cancelButtonText: 'Agora não'
      }).then((action) => {
        if (action.isConfirmed) navigate('/login')
      });
      return;
    }

    const response = await api.get(
      `/tournaments/info/${slugGI}`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );

    if (response.data.canSubscribe === false) {
      Swal.fire({
        title: 'Atenção!',
        text: 'Período de inscrição encerrado!',
        icon: 'error',
      });
      toast.error('Período de inscrição encerrado!');
      return;
    }

    navigate(`/enrollment/${slugGI}`)

  }
  return (
    <>
      <NavBar />

      <Container>
        <TournamentContainer
          image={require("../../assets/images/tournaments/copa-torneio-facil-de-jiu-jitsu/copa-torneio-facil-de-jiu-jitsu-old.jpg")}
        >
          <TournamentContainerBanner>
            <TournamentBanner
              image={require("../../assets/images/tournaments/copa-torneio-facil-de-jiu-jitsu/copa-torneio-facil-de-jiu-jitsu-old.jpg")}
            />
          </TournamentContainerBanner>
        </TournamentContainer>
        <TournamentContent>
          <Content>
            <Title>{tituloEvento}</Title>
            <Location>
              <Span>Data: {dataEvento}</Span>
              <Span>Início: {horaEvento}</Span>
              <Span>Local: {localEvento}</Span>
              <Span>Endereço: {endereçoEvento}</Span>
              <Span>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                  <FaMapMarkerAlt style={{ marginRight: '8px', color: "red" }} />
                  <a
                    target={"blank"}
                    style={{ color: "#000", textDecoration: "none", fontWeight: "bold" }}
                    href="#"
                  >
                    Ver no Google Maps
                  </a>
                </div>
              </Span>
            </Location>
            <P></P>
            <br />

          </Content>
        </TournamentContent>
        <TournamentDescription>
          <TournamentActions>
            <Content>
              <h1 style={{ textAlign: "center" }}>PATROCINADORES</h1>
              <SponsorContainer>
                <SponsorList>
                  {sponsors && sponsors.map((buttons: any, index: number) => (
                    <SponsorButton
                      key={index} // Adicionei uma chave única para cada botão
                      img={buttons.img}
                      url={buttons.url}
                      hasError={false}
                      error="Este campo é obrigatório"
                      target="_blank" // Adicione este atributo
                    />
                  ))}
                </SponsorList>
              </SponsorContainer>
              <h1 style={{ textAlign: "center" }}>APOIO</h1>
              <SponsorContainer>
                <SponsorList>
                  {support &&
                    support.map((buttons: any) => (
                      <SponsorButton
                        img={buttons.img}
                        url={buttons.url}
                        hasError={false}
                        error="Este campo é obrigatório"
                      />
                    ))}
                </SponsorList>
              </SponsorContainer>
            </Content>

            <Content style={{
              marginTop: '32px'
            }}>

              <EditalContainer>
                <EditalTitle>EDITAL {tituloEvento.toLocaleUpperCase()}</EditalTitle>
                <EditalContent>
                  <Span>
                    A {tituloEvento} é um evento  que
                    fomenta e incentiva a prática do jiu jitsu no BRASIL. As lutas
                    serão GI (com kimono) e NOGI (sem kimono), o evento disponibilizará
                    categorias para todas as idades e faixas, conforme a tabela de peso
                    deste edital. Os competidores terão a oportunidade de testar suas
                    habilidades em um ambiente controlado e com acompanhamento de
                    profissionais qualificados.
                  </Span>
                  <br />
                  <br />
                  <br />
                </EditalContent>

                <Collapse title="PROTOCOLO DE SEGURANÇA CONTRA COVID-19">
                vazio
                </Collapse>
                <Collapse title="PREMIAÇÕES:  DINHEIRO💰 + TROFÉU🏆 + MEDALHAS🥇 " >
                vazio
                </Collapse>
                <Collapse title="INSCRIÇÕES">
                vazio
                </Collapse>
                <Collapse title="PESSOAS COM DEFICIÊNCIA (PCD)">
                vazio
                </Collapse>
                <Collapse title="PAGAMENTO">
                vazio
                </Collapse>
                <Collapse title="REGRAS">
                vazio
                </Collapse>
                <Collapse title={"CRONOGRAMA"}>
                vazio
                </Collapse>
                <Collapse title="CONTATO">
                  <P>
                    Dúvidas sobre cadastro, inscrição, pagamento, correção, checagem ou
                    sugestão de melhorias entre em contato com a equipe do Torneio Fácil
                    por telefone ou WhatsApp.
                  </P>
                  <P>Melhor horário para atendimento das 18:00h as 23:59h.</P>
                  <a
                    target={"blank"}
                    href="https://whatsa.me/5511944563515/?t=Olá%20Equipe%20Torneio%20Fácil!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20na%20*I%20COPA%20FAIXA%20SOLIDÁRIA%20DE%20JIU%20JITSU%202025*"
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsAppTorneio} </strong>
                    <FaWhatsapp />
                  </a>

                  <br />
                </Collapse>
              </EditalContainer>
            </Content>
            <br />
            <Content>
               <TournamentEnrollmentLinkEndpage to={""} onClick={() => handleToSubscriptionPage()}>
                Inscrição
              </TournamentEnrollmentLinkEndpage> 
               <TournamentEnrollmentLinkEndpage to="/profile/subscription">
                Correção da Inscrição
              </TournamentEnrollmentLinkEndpage> 
              <TournamentLink target="blank" href={tabelaPeso}>
                Tabela de pesos
              </TournamentLink>
            </Content>
          </TournamentActions>
        </TournamentDescription>
      </Container>
      <Footer />
    </>
  );
};

export default CopaTorneioFacilDeJiuJitsu;
